import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import MeshMavenFooter from 'screens/performanceReview/components/ContinuousFeedback/Drawers/common/MeshMaven/Footer';
import MeshMaven from 'screens/performanceReview/components/ContinuousFeedback/Drawers/common/MeshMaven/MeshMaven';
import {
  setProvidedAnalysisError,
  setProvidedRephraseError,
} from 'screens/performanceReview/components/ContinuousFeedback/Drawers/slice/feedbackSlice';
import { useClearMutationCache } from 'utils/helpers/reactQueryHelpers';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { DrawerFooter } from 'uiToolkitV1/BottomDrawer';
import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { setPrimaryScreen, setSecondaryScreen, useCompetencyDrawerState } from '../competencyDrawerSlice';
import { PrimaryDrawerScreens, SecondaryDrawerScreens } from '../types/slice';

export const MeshMavenPanel = () => {
  const dispatch = useDispatch();

  const { selectedPrimaryScreen } = useCompetencyDrawerState();

  const clearMutationCache = useClearMutationCache();

  const closeMeshMaven = () => {
    dispatch(setPrimaryScreen(PrimaryDrawerScreens.COMPETENCY));
    dispatch(
      setSecondaryScreen(
        selectedPrimaryScreen === PrimaryDrawerScreens.REQUEST_FEEDBACK
          ? SecondaryDrawerScreens.REQUEST_FEEDBACK
          : SecondaryDrawerScreens.SHARE_FEEDBACK
      )
    );

    dispatch(
      setProvidedRephraseError({
        error: null,
      })
    );
    dispatch(
      setProvidedAnalysisError({
        error: null,
      })
    );
    clearMutationCache([REACT_QUERY_KEYS.RephraseText]);
    clearMutationCache([REACT_QUERY_KEYS.FeedbackAnalysis]);
  };

  return (
    <Flex flexDir="column" borderRadius="8px" bgColor="#FFFFFF" flex={1}>
      <Box p="12px" pb="8px !important">
        <TextBodyMedium bold>Maven</TextBodyMedium>
      </Box>
      <Divider borderColor="#CFD7DF" my={3} />
      <Box p={2} mb="auto" height="100%" overflow="hidden">
        <MeshMaven />
      </Box>
      <DrawerFooter h="72px" backgroundColor="neutral.F5F7F9">
        <MeshMavenFooter onCloseSecondaryPanel={closeMeshMaven} />
      </DrawerFooter>
    </Flex>
  );
};
